<template>
    <div class="thermometer-design-box">
      <design1 v-if="thermometer.design_type == 'D1'" :thermometer="thermometer"></design1>
      <design2 v-if="thermometer.design_type == 'D2'" :thermometer="thermometer"></design2>
      <design3 v-if="thermometer.design_type == 'D3'" :thermometer="thermometer"></design3>
    </div>
</template>

<script>
import Design1 from "./design/Design1.vue";
import Design2 from "./design/Design2.vue";
import Design3 from "./design/Design3.vue";
export default {
  name: "show-thermometer",
  props: {
    thermometer: {
      type: Object,
    },
  },
  components: {
    Design1,
    Design2,
    Design3,
  },
};
</script>

<style scoped>
.thermometer-design-box{
  padding: 10px;
}
</style>
